import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

function MyNav({ isEpkPage = false }) {
    const [scrolled, setScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Helper to determine href depending on if we are on the EPK page
    const getHref = (hash) => {
        return isEpkPage ? `/${hash}` : hash;
    };

    const handleLinkClick = (e, targetHref) => {
        if (targetHref.startsWith('#')) {
            e.preventDefault();
            setExpanded(false);
            
            setTimeout(() => {
                const id = targetHref.substring(1);
                // Handle scrolling to top vs specific sections
                if (id === 'top') {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                    const element = document.getElementById(id);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            }, 350); // Wait for the Bootstrap menu collapse transition (350ms)
        } else {
            setExpanded(false);
        }
    };

    return (
        <Navbar
            sticky='top'
            expand="lg"
            expanded={expanded}
            onToggle={(isOpen) => setExpanded(isOpen)}
            className={`navbar-claire ${scrolled ? 'scrolled' : ''}`}
        >
            <Container className='container-claire'>
                {/* Brand title on mobile / left side if desired, but we keep it empty or simple */}
                <Navbar.Brand href="/" className="nav-brand-text font-heading text-uppercase text-light" style={{ letterSpacing: '0.1em' }} onClick={(e) => handleLinkClick(e, '/')}>
                    Bellbird
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ borderColor: 'rgba(234, 232, 223, 0.5)', filter: 'invert(1)' }} />
                <Navbar.Collapse id="navbar-collapse-id">
                    <Nav className="ms-auto align-items-center">
                        <a className='nav-link-claire' href={getHref('#top')} onClick={(e) => handleLinkClick(e, getHref('#top'))}>Home</a>
                        <a className='nav-link-claire' href={getHref('#about')} onClick={(e) => handleLinkClick(e, getHref('#about'))}>About</a>
                        <a className='nav-link-claire' href={getHref('#music')} onClick={(e) => handleLinkClick(e, getHref('#music'))}>Music</a>
                        <a className='nav-link-claire' href={getHref('#tour')} onClick={(e) => handleLinkClick(e, getHref('#tour'))}>Tour</a>
                        <a className='nav-link-claire' href={getHref('#press')} onClick={(e) => handleLinkClick(e, getHref('#press'))}>Press</a>
                        <a className='nav-link-claire' href="https://bellbirdband.bandcamp.com/merch" target='_blank' rel='noreferrer' onClick={(e) => handleLinkClick(e, 'https://bellbirdband.bandcamp.com/merch')}>
                            Shop <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '11px', marginLeft: '4px' }} />
                        </a>
                        <a className='nav-link-claire' href={getHref('#contact')} onClick={(e) => handleLinkClick(e, getHref('#contact'))}>Contact</a>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MyNav;